<!-- Full Width Container -->
<div class="py-8">

	<!-- Centered Content Box -->
	<div class="pixel-9-slice">
		<div class="max-w-4xl mx-auto bg-base-100 p-8 min-h-[600px] sm:pb-[0px] pb-[170px]">
			<h2>SIGN UP</h2>
			<p class="text-base-content/60 text-xs mt-2 mb-8">Sign up to get started.</p>

			<!-- Error Message -->
			@if (errorMessage()) {
				<div class="bg-error/10 border border-error text-error p-3 rounded mb-4">
					{{ errorMessage() }}
				</div>
			}

			<!-- Signup Form -->
			<form (ngSubmit)="onSubmit()" #signupForm="ngForm">
				<!-- Email Field -->
				<div class="mb-5">
					<label for="email" class="block mb-1.5 text-base-content font-medium">Email Address</label>
					<input
						type="email"
						id="email"
						name="email"
						[(ngModel)]="email"
						required
						class="w-full p-3 border-2 rounded"
						[class.border-error]="signupForm.form.get('email')?.invalid && signupForm.form.get('email')?.touched"
						[class.border-base-300]="!(signupForm.form.get('email')?.invalid && signupForm.form.get('email')?.touched)"
						placeholder="Enter email"
						(blur)="signupForm.form.get('email')?.markAsTouched()"
					>
				</div>

				<!-- Password Field -->
				<div class="mb-5">
					<label for="password" class="block mb-1.5 text-base-content font-medium">Password</label>
					<div class="relative">
						<input
							[type]="showPassword() ? 'text' : 'password'"
							id="password"
							name="password"
							[(ngModel)]="password"
							required
							minlength="6"
							class="w-full p-3 pr-12 border-2 rounded"
							[class.border-error]="signupForm.form.get('password')?.invalid && signupForm.form.get('password')?.touched"
							[class.border-base-300]="!(signupForm.form.get('password')?.invalid && signupForm.form.get('password')?.touched)"
							placeholder="Create password"
							(blur)="signupForm.form.get('password')?.markAsTouched()"
						>
					<button
						type="button"
						(click)="togglePasswordVisibility()"
						class="absolute right-3 top-1/2 transform -translate-y-1/2 bg-transparent border-none cursor-pointer text-base-content/60 p-0"
					>
						@if (showPassword()) {
							<eye-slash-icon [color]="'currentColor'" [size]="20"></eye-slash-icon>
						} @else {
							<eye-icon [color]="'currentColor'" [size]="20"></eye-icon>
						}
					</button>
					</div>
					<p class="mt-3 mx-2 text-base-content/50 text-xs">Must be at least 6 characters long.</p>
				</div>

				<!-- Confirm Password Field -->
				<div class="mb-6">
					<label for="confirmPassword" class="block mb-1.5 text-base-content font-medium">Confirm Password</label>
					<div class="relative">
						<input
							[type]="showConfirmPassword() ? 'text' : 'password'"
							id="confirmPassword"
							name="confirmPassword"
							[(ngModel)]="confirmPassword"
							required
							class="w-full p-3 pr-12 border-2 rounded"
							[class.border-error]="signupForm.form.get('confirmPassword')?.invalid && signupForm.form.get('confirmPassword')?.touched"
							[class.border-base-300]="!(signupForm.form.get('confirmPassword')?.invalid && signupForm.form.get('confirmPassword')?.touched)"
							placeholder="Confirm password"
							(blur)="signupForm.form.get('confirmPassword')?.markAsTouched()"
						>
					<button
						type="button"
						(click)="toggleConfirmPasswordVisibility()"
						class="absolute right-3 top-1/2 transform -translate-y-1/2 bg-transparent border-none cursor-pointer text-base-content/60 p-0"
					>
						@if (showConfirmPassword()) {
							<eye-slash-icon [color]="'currentColor'" [size]="20"></eye-slash-icon>
						} @else {
							<eye-icon [color]="'currentColor'" [size]="20"></eye-icon>
						}
					</button>
					</div>
				</div>

			<!-- Submit Button -->
			<button
				type="submit"
				[disabled]="isLoading() || signupForm.form.invalid"
				class="red-cta-btn-xlg retro-pixel-regular my-4"
			>
				@if (isLoading()) {
					<span>LOADING</span>
				} @else {
					<span>SIGN UP</span>
				}
			</button>
			</form>

			<hr class="border-t-4 border-gray-300 my-8">

			<!-- Links -->
			<div class="flex flex-col gap-2 mb-4  items-start">
				<p class="text-base-content/60 m-0 text-sm">
					Already have an account?
					<button
						type="button"
						(click)="goToLogin()"
						class="bg-transparent border-none text-primary cursor-pointer"
					>
					SIGN IN
					</button>
				</p>
			</div>

		</div>
	</div>

	<!-- Overlaid Crustopher -->
	<div class="crustopher-overlay">
		<img [src]="avatarImage()" alt="Crustopher Avatar" class="crustopher-image" (click)="onAvatarClick()">
	</div>

</div>
